const SHARED = {
  STANDARD_TYPE: {
    SPC_BBK: 'SPC_BBK',
    WEBAUTHN: 'WEBAUTHN',
  },
  ACTOR_TYPE: {
    CARDMEMBER: 'CARDMEMBER',
    CCP: 'CCP',
    ISSUER_SYSTEM: 'ISSUER_SYSTEM',
    NETWORK_SERVICE: 'NETWORK_SERVICE',
  },
  FLOW_TYPE: {
    REGISTRATION: 'REGISTRATION',
    AUTHENTICATION: 'AUTHENTICATION',
  },
  COMMON: {
    DISPLAY_NAME: 'Amex Card',
  },
};

export default SHARED;
